import { render } from "./EditorChild.vue?vue&type=template&id=eb070abe&scoped=true"
import script from "./EditorChild.vue?vue&type=script&lang=js"
export * from "./EditorChild.vue?vue&type=script&lang=js"

import "./EditorChild.vue?vue&type=style&index=0&id=eb070abe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb070abe"]])

export default __exports__